import { render, staticRenderFns } from "./CollectionNotReceiveAmountList.vue?vue&type=template&id=098b8c3b&scoped=true"
import script from "./CollectionNotReceiveAmountList.vue?vue&type=script&lang=js"
export * from "./CollectionNotReceiveAmountList.vue?vue&type=script&lang=js"
import style0 from "./CollectionNotReceiveAmountList.vue?vue&type=style&index=0&id=098b8c3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098b8c3b",
  null
  
)

export default component.exports